export default "__VITE_ASSET__BVsVJxZZ__"